import Cookies from 'js-cookie';

export const getlevel = () => {
    return Cookies.get("level")
};

export const permission = {
    Companies: ['Super Admin'],
    Users: ['Super Admin', 'Admin',],
    Integrations: ['Super Admin', 'Admin', 'Integ Special', 'Integ User', 'Integ Monitor'],
    In_bound: ['Super Admin', 'Admin', 'Integ Special', 'Integ User', 'Integ Monitor'],
    Out_bound: ['Super Admin', 'Admin', 'Integ Special', 'Integ User', 'Integ Monitor'],
}